var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"yx-color-text-primary"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.formatTime?.date)))]),_c('div',{staticClass:"yx-color-text-secondary"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.formatTime?.time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }